import ui from './ui';
import user from './user';
import core from './core';
import intl from './intl';
import social from './social';
import soundtrack from './soundtrack';
import ranking from './ranking';
import analytics from './analytics';
import characters from './characters';
import screenshots from './screenshots';

export default {
    ui,
    user,
    core,
    intl,
    social,
    soundtrack,
    ranking,
    analytics,
    characters,
    screenshots,
}